import { render, staticRenderFns } from "./b-popup-process-step.vue?vue&type=template&id=59addc90&scoped=true"
import script from "./b-popup-process-step.vue?vue&type=script&lang=js"
export * from "./b-popup-process-step.vue?vue&type=script&lang=js"
import style0 from "./b-popup-process-step.vue?vue&type=style&index=0&id=59addc90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59addc90",
  null
  
)

export default component.exports